import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { NAV, COMPANY, ACCREDITATIONS } from "@/data/site";

const LEGAL = [
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Website Terms", to: "/website-terms" },
  { label: "Cookie Policy", to: "/cookie-policy" },
  { label: "Accessibility", to: "/accessibility" },
  { label: "Sitemap", to: "/sitemap" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[#0A1128] text-white">
      <div className="noise" />
      <div className="container-x relative py-20">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="font-display text-4xl uppercase leading-none tracking-tight md:text-5xl">
              Andrews Building<br />Company Ltd
            </p>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
              {COMPANY.tagline}
            </p>
            <div className="mt-8 flex flex-wrap gap-x-6 gap-y-2 text-xs uppercase tracking-widest text-slate-500">
              {ACCREDITATIONS.map((a) => (
                <span key={a}>{a}</span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="font-display text-xs uppercase tracking-[0.25em] text-slate-500">Explore</p>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link
                    to={n.to}
                    data-testid={`footer-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-slate-300 transition-colors hover:text-white"
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="font-display text-xs uppercase tracking-[0.25em] text-slate-500">Get in touch</p>
            <ul className="mt-5 space-y-4 text-sm text-slate-300">
              <li className="flex items-start gap-3">
                <Phone size={18} className="mt-0.5 text-[#4b6bd6]" />
                <a href={COMPANY.phoneHref} data-testid="footer-phone" className="transition-colors hover:text-white">{COMPANY.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={18} className="mt-0.5 text-[#4b6bd6]" />
                <a
                  href={`mailto:${COMPANY.email}`}
                  data-testid="footer-email"
                  className="group inline-flex items-center gap-1 transition-colors hover:text-white"
                >
                  {COMPANY.email}
                  <ArrowUpRight size={14} className="opacity-0 transition-opacity group-hover:opacity-100" />
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="mt-0.5 text-[#4b6bd6]" />
                <span>{COMPANY.addressLine}</span>
              </li>
            </ul>
            <p className="mt-6 text-xs uppercase tracking-widest text-slate-500">
              Serving {COMPANY.region}
            </p>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-6 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
          <p className="text-xs text-slate-500">
            &copy; {new Date().getFullYear()} Andrews Building Company Limited &middot; Registered in England &amp; Wales, company no. 04982965
          </p>
          <ul className="flex flex-wrap gap-x-6 gap-y-2">
            {LEGAL.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-legal-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-xs uppercase tracking-wider text-slate-400 transition-colors hover:text-white"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
}
